/* global browser  */
// qq浏览器分享初始化
import { isFunction } from '../../common/base';
export default function (opt) {
  // 如果不是qq浏览器，返回false
  if (typeof browser === 'undefined') {
    return false;
  }

  var objects = {
    url: opt.shareUrl,
    // 分享后点击的页面url
    title: opt.title,
    // 分享界面的标题
    description: opt.desc,
    // 分享界面的描述
    img_url: opt.imageUrl
  };
  browser.app.share(objects, function () {
    // 分享成功的回调函数，目前仅在Android的5.4版本以上的QQ浏览器上可用
    // opt.code ==1 表示能分享
    // opt.code ==-1 表示不能分享
    // opt.code == 0 表示未知
    if (isFunction(opt.qqBrowserCallback)) {
      opt.qqBrowserCallback(opt);
    }
  });
}